import { memo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import RadioItem from './RadioItem';

export * from './RadioItem';

export default hoistNonReactStatics(memo(RadioItem), RadioItem);
